import React, { useMemo, useState } from 'react';
import { useListingUnsubscribedDomains } from '../../../query/unsubscribe';
import { Row, Select, SelectOption, Table } from '../../../components/ui';
import moment from 'moment/moment';
import DomainUnsubscribeForm from './DomainUnsubscribeForm';
import DomainResubscribeButton from './DomainResubscribeButton';
import { useGetAllEmailTypes } from '../../../query/mail';
import { Button, Icon, Spin } from 'antd';
import { useUnsubscribeDomain } from '../../../mutation/unsubscribe';

function EmailTypeCell({ emailTypesData = [], domain }) {
  const { isLoading, mutateAsync } = useUnsubscribeDomain();
  const [isEdit, setIsEdit] = useState(false),
    [emailTypeId, setEmailTypeId] = useState(domain.email_type_id || 0);
  if (!isEdit) {
    let text;
    if (!domain.email_type_id) text = 'All Email Types';
    else text = emailTypesData.find(e => e.id === domain.email_type_id)?.type;
    return (
      <div className="flex items-center space-x-2">
        <p style={{ marginBottom: 0 }}>{text}</p>
        <Button icon="edit" onClick={() => setIsEdit(true)} />
      </div>
    );
  }
  return (
    <Spin spinning={isLoading}>
      <div className="flex items-center space-x-2">
        <Select value={emailTypeId} onChange={setEmailTypeId}>
          <SelectOption key="default" value={0}>
            All Email Types
          </SelectOption>
          {emailTypesData.map(emailType => (
            <SelectOption key={emailType.id} value={emailType.id}>
              {emailType.type}
            </SelectOption>
          ))}
        </Select>
        <Icon
          style={{ fontSize: 22 }}
          theme="twoTone"
          twoToneColor="#52c41a"
          type="check-circle"
          onClick={() => {
            mutateAsync({
              ...domain,
              emailTypeId: emailTypeId ? Number(emailTypeId) : 0,
            })
              .then(() => setIsEdit(false))
              .catch(() => {});
          }}
        />
        <Icon
          style={{ fontSize: 22 }}
          theme="twoTone"
          twoToneColor="#ff3333"
          type="close-circle"
          onClick={() => {
            setEmailTypeId(domain.email_type_id);
            setIsEdit(false);
          }}
        />
      </div>
    </Spin>
  );
}

export default function DomainUnsubscriptionSection() {
  const { data, isLoading } = useListingUnsubscribedDomains();
  const {
    data: emailTypesData,
    isLoading: emailTypesLoading,
  } = useGetAllEmailTypes();
  const tableColumns = useMemo(() => {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: 'Domain',
        dataIndex: 'domain',
        key: 'domain',
      },
      {
        title: 'Email Type',
        render: (_, domain) => {
          return (
            <EmailTypeCell domain={domain} emailTypesData={emailTypesData} />
          );
        },
      },
      {
        title: 'actions',
        render: (actions, { id }) => (
          <DomainResubscribeButton id={id} key={id} />
        ),
      },
      {
        title: 'Created Date',
        dataIndex: 'date_created',
        key: 'date_created',
        render: date => {
          return moment(date).format('YYYY-MM-DD HH:mm');
        },
      },
    ];
  }, [emailTypesData]);
  return (
    <>
      <DomainUnsubscribeForm />
      <Row>
        <Table
          columns={tableColumns}
          dataSource={data}
          loading={isLoading || emailTypesLoading}
          rowKey="id"
        />
      </Row>
    </>
  );
}
